import React, { useEffect, useRef, forwardRef } from "react";
import styles from "./style.module.scss";
import {
  Chart,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  CategoryScale,
  LinearScale,
  Title,
  RadialLinearScale,
  DatasetController,
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";
import Zoom from "chartjs-plugin-zoom";
Chart.register(
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  ChartDataLabels,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  Zoom
);

const CustomChart = forwardRef(
  ({ type, data, options, plugins, width, height, dependency }, ref) => {
    const chartInstanceRef = useRef(null);
    const canvasRef = useRef(null);
    const chartRef = ref || chartInstanceRef;

    useEffect(() => {
      const canvas = canvasRef.current;
      if (!canvas) return undefined;

      // Destroy existing chart if present
      if (chartRef?.current) {
        chartRef.current.destroy();
      }
      const chartConfig = {
        type: type,
        data: data,
        options: {
          ...options,
          backgroundColor: 'transparent',
          layout: {
            ...options?.layout,
            padding: {
              left: 10,
              right: 10,
              top: 10,
              bottom: 10,
              ...options?.layout?.padding,
            },
          },
        },
        plugins: plugins,
      };
      const ctx = canvas.getContext("2d");
      chartRef.current = new Chart(ctx, chartConfig);

      const resizeChart = () => {
        if (chartRef.current) {
          chartRef.current.resize();
        }
      };
      const resizeTarget = canvas.parentElement;
      let resizeObserver;
      if (resizeTarget && typeof ResizeObserver !== "undefined") {
        resizeObserver = new ResizeObserver(resizeChart);
        resizeObserver.observe(resizeTarget);
      }
      const rafId = requestAnimationFrame(resizeChart);

      return () => {
        cancelAnimationFrame(rafId);
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
        if (chartRef.current) {
          chartRef.current.destroy();
        }
      };
    }, [dependency ? dependency : data]);
    return <canvas ref={canvasRef} width={width} height={height} style={{ background: 'transparent' }} />;
  }
);

export default CustomChart;
